export default "__VITE_ASSET__bfa1e6dc__"